import styles from "../styles/entity.module.css";

export const buildTreeMap = (data, idKey = "id", parentKey = "parentId") => {
  const map = {};
  data.forEach((item) => {
    item.children = [];
    map[item[idKey]] = item;
  });
  const roots = [];
  data.forEach((item) => {
    if (item[parentKey] && map[item[parentKey]]) {
      map[item[parentKey]].children.push(item);
    } else {
      roots.push(item);
    }
  });
  return roots;
};

const typeClassMap = {
  Parent: styles.root,
  Level_1_Company: styles.nodeLevel1Company,
  Level_2_Company: styles.nodeLevel2Company,
  Level_3_Company: styles.nodeLevel3Company,
  Facilities: styles.nodeFacilities,
};

export const getCompanyNodeClass = (type) => typeClassMap[type] ?? styles.node;



//取得 Operator(roleId===4) 在 Facility 時，
//editable 節點的上層路徑 id 集合（排除 Facility 本身與 root/depth===0）
export function getAncestorIdsForOperator(list) {
  // Operator 只有一個 editable 節點，且為 Facilities 類型
  const editableNode = list.find(
    (item) => item.nodeStatus === "editable" && item.type === "Facilities",
  );
  console.log("✅ editableNode:", editableNode); // 確認有沒有找到節點
  if (!editableNode) return new Set();

  // level 格式: "rootId/...中間層.../facilityId"
  // 切割後去掉第一個(root)和最後一個(Facility 本身)
  const levelIds = editableNode.level.split("/");
  console.log("✅ levelIds:", levelIds);
  const ancestorIds = levelIds.slice(1, -1); // 去頭(root)去尾(自身)
  console.log("✅ ancestorIds:", ancestorIds);

  return new Set(ancestorIds);
}
